import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_PERFILES,
  ALL_PERFILES,
  LOADING_ALL_PERFILES,
} from './PerfilesReducer';
import {
  allPerfilesService,
  deletePerfilesService,
  onePerfilesService,
  savePerfilesService,
} from './PerfilesService';

export const allPerfilesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_PERFILES, payload: true });
    const res = await allPerfilesService(params);

    dispatch({ type: ALL_PERFILES, payload: res.data });
    dispatch({ type: LOADING_ALL_PERFILES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_PERFILES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const savePerfilesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await savePerfilesService(id, data);
    notify(res.data.message);
    await allPerfilesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoPerfilesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_PERFILES, payload: data });
};

export const onePerfilesAction = async (dispatch, id) => {
  try {
    const res = await onePerfilesService(id);
    await setActivoPerfilesAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deletePerfilesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deletePerfilesService(id);
    notify(res.data.message);
    await setActivoPerfilesAction(dispatch, null);
    await allPerfilesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
